import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Input,
  Theme,
  useTheme,
} from "@material-ui/core";
import React, { useEffect } from "react";
import { Field } from "features/admin/Products/types";
import { useStyles } from "./styles";
import { Controller } from "react-hook-form";

interface MultiselectFieldProps {
  item: Field;
  control: any;
  reset: boolean | undefined;
  setValue: any;
}
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(name: string, personName: string[], theme: Theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}
const MultiselectField: React.FC<MultiselectFieldProps> = ({
  item,
  control,
  reset,
  setValue,
}) => {
  const classes = useStyles();
  const labelId = `${item.name}-label`;
  const [_values, setValues] = React.useState<string[]>(
    item.value ? item.value : []
  );
  const theme = useTheme();
  useEffect(() => {
    if (reset !== undefined) {
      setValues(item.value ? item.value : []);
    }
  }, [reset]);
  const handleChange = (
    event: React.ChangeEvent<{ value: unknown }>,
    onChange: any
  ) => {
    setValues(event.target.value as string[]);
    onChange(event);
  };
  useEffect(() => {
    setValues(item.value ? item.value : []);
    setValue(item.name, item.value);
  }, []);
  return (
    <FormControl required={item.required} className={classes.formControl}>
      <InputLabel id={labelId}>{item.title}</InputLabel>
      <Controller
        name={item.name}
        control={control}
        defaultValue={[]}
        render={({ onChange, onBlur, name }) => (
          <Select
            labelId={labelId}
            id={item.name}
            name={name}
            multiple
            value={_values}
            onChange={(e) => handleChange(e, onChange)}
            onBlur={onBlur}
            inputProps={{
              id: `${item.name}-native-input`,
              "aria-labelledby": labelId,
            }}
            input={<Input />}
            MenuProps={MenuProps}
          >
            {item.options!.map((option, idx) => (
              <MenuItem
                key={option}
                value={option}
                style={getStyles(option, _values, theme)}
              >
                {option}
              </MenuItem>
            ))}
          </Select>
        )}
      />

      {item.required && <FormHelperText>Задължително</FormHelperText>}
    </FormControl>
  );
};

export default MultiselectField;
